
































import Vue from 'vue';
import { Link } from '~/services/CandidateService';
import { commonProps } from '~/utils/candidate';
import LinksModal from '../modals/LinksModal.vue';
import Card from './Card.vue';

export default Vue.extend({
    name: 'Links',
    components: {
        Card,
        LinksModal,
    },
    props: {
        ...commonProps(),
    },
    data() {
        return {
            showModal: false,
        };
    },
    computed: {
        hasNoLinks(): boolean {
            return !this.candidate.links.length;
        },
        cardTitle(): string {
            return this.hasNoLinks
                ? this.$t('profile.links.titleWhenEmpty').toString()
                : this.$t('profile.links.title').toString();
        },
        links(): Link[] {
            return [...this.candidate.links].sort((a, b) => a.name.localeCompare(b.name));
        },
    },
});
